<template>
    <div id="app" v-bind:class="{
        'login': !getToken,
    }">
        <template v-if="getToken">
            <div class="ui" v-bind:class="{
                open: isSidebarOpen,
            }">
                <div class="sidebar-wrapper">
                    <div class="sidebar">
                        <div>
                            <Sidebar />
                        </div>
                    </div>
                </div>
                <div class="viewport">
                    <Navigation />
                    <InterfaceMessage />
                    <main>
                        <router-view />
                    </main>
                </div>
            </div>
        </template>
        <template v-else>
            <Login />
        </template>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Login from '@/components/Login.vue'
import Loader from '@/components/Loader.vue'
import Navigation from '@/components/Navigation.vue'
import Table from '@/components/Table.vue'
import Tabsheet from '@/components/Tabsheet.vue'
import Tab from '@/components/Tab.vue'
import Grid from '@/components/Grid.vue'
import Dropdown from '@/components/Dropdown.vue'
import InputRow from '@/components/InputRow.vue'
import SvgFile from '@/components/SvgFile.vue'
import InterfaceMessage from '@/components/InterfaceMessage.vue'
import Sidebar from '@/components/Sidebar.vue'

Vue.component('InterfaceMessage', InterfaceMessage)
Vue.component('Sidebar', Sidebar)
Vue.component('SvgFile', SvgFile)
Vue.component('Loader', Loader)
Vue.component('Table', Table)
Vue.component('Tabsheet', Tabsheet)
Vue.component('Tab', Tab)
Vue.component('Grid', Grid)
Vue.component('Dropdown', Dropdown)
Vue.component('InputRow', InputRow)

export default {
  components: {
    Navigation,
    Login
  },
  computed: {
    ...mapGetters([
      'getToken',
      'getStylist',
      'isSidebarOpen'
    ])
  },
  watch: {
    $route (to, from) {
      document.title = 'AnnoAnno'
    }
  },
  methods: {
    toggleSidebar () {
      this.$store.commit('setSidebarOpen', !this.isSidebarOpen)
    }
  },
  created () {
    console.log(Vue.$env)
    console.log(Vue.$env.get())
    if (this.getStylist.id) {
      this.$store.dispatch('loadRepositories')
    }
  }
}
</script>

<style lang="less">
@import './styles/main.less';
    body {
        font-family: @font;
        margin: 0;
        font-size: 15px;
        font-weight: 300;
        overflow-y: scroll;
    }
    main {
      padding: 70px 15px 100px 15px;
    }

    @sidebar-size: 400px;

    .ui {
        .sidebar-wrapper, .sidebar, nav {
            transition: 300ms;
        }
    }

    .ui {
        display: flex;
        .sidebar-wrapper {
            position: relative;
            width: @sidebar-size;
            margin-left: -@sidebar-size;
            background: #fff;
            min-height: 100vh;
            .sidebar {
                position: fixed;
                top: 0px;
                left: -@sidebar-size;
                bottom: 0px;
                width: @sidebar-size - 60px;
                border-right: 1px solid #aaa;
                background: #fff;
                padding: 30px;
                overflow-y: auto;
            }
        }
        .viewport {
            width: 100%;
            nav {
                left: 0px;
            }
        }
        &.open {
            .sidebar-wrapper {
                margin-left: 0px;
                .sidebar {
                    left: 0px;
                    background: #fff;
                    z-index: 1000;
                }
            }
            .viewport {
                nav {
                    left: @sidebar-size + 1px;
                }
            }
        }
    }

    .completion-dots {
        .completion-dot {
            text-align: center;
                width: 200px;
            .the-dot {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 26px;
                height: 26px;
                border: 2px solid rgba(0, 0, 0, 0.2); // #ccc;
                border-radius: 50%;
                margin: auto;
                margin-bottom: 8px;
                svg {
                    fill: #fff;
                }
                .svg-icon svg, .svg-icon {
                    width: 18px !important;
                    height: 18px !important;
                }
            }
            .note {
                margin-top: 2px;
            }
            &.completed {
                .the-dot {
                    background: linear-gradient(45deg, lighten(@green, -3%), lighten(@green, 5%));
                }
            }
            &.danger {
                .the-dot {
                    background: linear-gradient(45deg, lighten(@red, -3%), lighten(@red, 5%));
                }
            }
            &.orange {
                .the-dot {
                    background: linear-gradient(45deg, lighten(@orange, -3%), lighten(@orange, 5%));
                }
            }
        }
    }

    .dropdown-list {
        border: 1px solid #ddd;
        display: none;
        position: absolute;
        background: #fff;
        z-index: 1000;
        &.show {
            display: flex;
        }
        .list {
            width: 250px;
            padding-top: 7px;
            padding-bottom: 7px;
        }
        .dropdown-content {
            width: 300px;
            border-left: 1px solid #ddd;
            padding: 20px;
            font-size: 15px;
            font-weight: 300;
            text-transform: none;
            h2 {
                margin: 0px;
                font-size: 20px;
            }
        }
        .dropdown-list-item {
            cursor: pointer;
            padding: 7px;
            margin-left: 7px;
            margin-right: 7px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #535353;
            position: relative;
            .svg-icon {
                margin-right: 8px;
                width: 22px !important;
                height: 22px !important;
                svg {
                    fill: #535353;
                    width: 22px !important;
                    height: 22px !important;
                }
            }
            &:hover:not(.disabled) {
                background: linear-gradient(45deg, lighten(@blue, -3%), lighten(@blue, 6%));
                color: #fff;
                > .svg-icon svg, &.has-dropdown > .arrow svg {
                    fill: #fff;
                }
            }
            &.disabled {
                cursor: not-allowed;
                opacity: 0.7;
            }
            > .dropdown-list {
                top: 0px;
            }
            &:not(.on-right) {
              > .dropdown-list {
                left: 98%;
              }
            }
            &.on-right {
              > .dropdown-list {
                right: 98%;
              }
            }
            &.has-dropdown {
                .arrow {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    top: 0px;
                    right: -6px;
                    bottom: 0px;
                }
            }
        }
        .dropdown-list-separator {
            margin-top: 8px;
            margin-bottom: 8px;
            height: 1px;
            background: #ddd;
        }
    }

    .exchange-requst-overview {
        .exchange-request {
            margin-top: 30px;
            border: 1px solid #efefef;
            .headline {
                padding: 16px;
                padding-bottom: 11px;
                border-bottom: 1px solid #efefef;
                background: #f6f6f6;
            }
            .details {
            }
        }
    }

    .separator {
        margin-top: 30px;
        margin-bottom: 30px;
        border-top: 1px dashed #ccc;
    }

    #app.login {
        .background {
            position: fixed;
            top: 0px;
            left: 240px;
            right: 0px;
            bottom: 0px;
            filter: blur(0px);
            background-position: center center;
            background-size: cover;
            background-image: url('https://images.pexels.com/photos/3847485/pexels-photo-3847485.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260');
        }
        .login-elements {
            background: #fff;
            display: flex;
            justify-content: center;
            flex-direction: column;
            position: fixed;
            top: 0px;
            bottom: 0px;
            width: 240px;
            padding-left: 70px;
            padding-right: 70px;
            border-right: 2px solid #232323;
            box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.3);
        }
    }

    nav {
        position: fixed;
        right: 0px;
        background: #fff;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
        z-index: 500;
        .menu-item {
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 100;
            padding: 20px;
            padding-bottom: 25px;
            padding-top: 25px;
            cursor: pointer;
            .items {
                text-align: left;
                width: 260px;
                background: #fff;
                box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.4);
                border-top: 2px solid darken(@base-color, 10%);
                top: -700px;
                top: ~"calc(100% - 25px)";
                left: 0px;
                position: absolute;
                display: flex;
                display: none;
                transition: 300ms;
                flex-direction: column;
                color: @base-color;
                a {
                    font-weight: 700;
                    font-size: 14px;
                    padding: 16px;
                    padding-left: 8px;
                    &:last-child {
                        border-bottom: none;
                        margin: 0px;
                    }
                    &:hover {
                        background: lighten(@base-color, 70%);
                        text-decoration: none;
                    }
                }
            }
            &:hover {
                background: lighten(@base-color, 70%);
                .items {
                    display: flex;
                }
            }
        }
        .base-width, .nav-wrapper {
            margin: auto;
            display: flex;
        }
        .logo {
            display: flex;
            align-items: center;
            padding-left: 10px;
            width: 100px;
            img {
                height: 30px;
            }
        }
        .account {
            width: 100px;
        }
        .navigation {
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            > a, .menu-item {
                text-align: center;
                margin-left: 0px;
                margin-right: 0px;
            }
            a, .menu-item .title {
                // text-transform: uppercase;
                font-weight: 700;
                flex-grow: 0;
                flex-shrink: 0;
                font-size: 15px;
                color: @base-color;
                &:link, &:visited {
                    text-decoration: none;
                }
            }
            .group {
                // margin: 15px;
                strong {
                    padding: 10px;
                    padding-top: 30px;
                    display: block;
                    font-size: 13px;
                    font-weight: 900;
                    text-transform: uppercase;
                    // border-bottom: 1px solid #;
                }
                a {
                    display: block;
                }
            }
        }
    }
    #search {
        width: 200px;
        // input {
            text-align: right;
        // }
    }
    select {
        padding: 10px;
        border-radius: 4px;
        border: 1px solid @border-color;
    }
    input, select {
        font-family: @font;
        &[type=text], &[type=password], &[type=number] {
            padding: 10px;
            border-radius: 4px;
            border: 1px solid @border-color;
        }
        &.short {
            width: 40px;
        }
        &.long {
            width: 200px;
        }
    }
    button {
        font-weight: 700;
        background: @base-color;
        // border-radius: 4px;
        color: #fff;
        padding: 14px;
        padding-left: 24px;
        padding-right: 24px;
        text-transform: uppercase;
        font-family: @font;
        border: none;
        cursor: pointer;
        transition: 120ms;
        position: relative;
        &::after {
            content: "";
            background: rgba(255, 255, 255, 0.07);
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: ~"calc(100% - 0px)";
            position: absolute;
            transition: 250ms;
            z-index: 0;
        }
        &:hover {
            background: lighten(@base-color, 10%);
            .info {
                transform: none;
            }
            &::after {
                right: 0%;
            }
        }
        &.light {
            background: #e0e0e0;
            color: @base-color;
            &:hover {
                background: #e6e6e6;
            }
        }
        &.transparent {
            background: transparent;
            color: #fff;
            border: 2px solid #fff;
        }
        &.gray {
            background: #ddd;
            color: #323232;
            &:hover {
                background: #e5e5e5;
            }
        }
        &.danger {
            background: darken(@red, 10%);
            color: #fff;
            &:hover {
                background: lighten(@red, 0%);
            }
        }
        &[disabled] {
            background: #777;
            cursor: not-allowed;
            &:hover {
                background: #777;
            }
        }
        &.white {
            background: #fff;
            color: @base-color;
            // border: 2px solid #eee;
            &[disabled] {
                background: #fff;
                color: #aaa;
                border-color: #aaa;
                cursor: not-allowed;
                &:hover {
                    background: #fff;
                }
            }
            &::after {
                background: rgba(0, 0, 0, 0.035);
            }
        }
        &.smaller, &.small {
            padding: 8px;
            padding-left: 10px;
            padding-right: 10px;
            font-size: 13px;
        }
        .info {
            transition: 200ms;
            z-index: 100;
            transform: scale(0, 0);
            position: absolute;
            top: ~"calc(100% + 10px)";
            left: 0px;
            color: #323232;
            width: 200px;
            pointer-events: none;
            font-weight: 300;
            font-size: 13px;
            text-transform: none;
            text-align: left;
            padding: 15px;
            border: 1px solid #535353;
            border-radius: 2px;
            background: #fff;
            box-shadow: 0px 0px 4px rgba(0,0,0,0.2);
        }
    }
    .tabsheet {
        .tab {
            margin-top: 30px;
        }
    }
    .content {
        padding-top: 30px;
        width: @base-width;
        margin: auto;
        h1 {
            margin: 0;
        }
    }
    .full-width { width: 100%; }
    .flex {
        display: flex;
        &.align-items {
            align-items: center;
        }
        &.flex-wrap {
            flex-wrap: wrap;
        }
    }
    .horizontal-flex-end {
        justify-content: flex-end;
    }
    .flex-grow {
        flex-grow: 1;
    }
    .flex-basis {
        flex-grow: 1;
        flex-basis: 0;
    }
    .text-center {
        text-align: center;
    }
    .text-right {
        text-align: right;
    }
    .strikethrough {
        text-decoration: line-through;
    }

    .clickable { cursor: pointer; }

    .base-width { width: @base-width; }
    .no-padding { padding: 0px; }
    .no-margin { margin: 0px; }

    .small-padding-bottom { padding-bottom: 15px; }
    .small-padding-left { padding-left: 15px; }
    .small-padding-right { padding-right: 15px; }
    .small-padding-top { padding-top: 15px; }
    .small-padding { padding: 15px; }
    .padding-bottom { padding-bottom: 30px; }
    .padding-left { padding-left: 30px; }
    .padding-right { padding-right: 30px; }
    .padding-top { padding-top: 30px; }
    .padding { padding: 30px; }

    .xs-margin-bottom, .very-small-margin-bottom { margin-bottom: 6px; }
    .xs-margin-left, .very-small-margin-left { margin-left: 6px; }
    .xs-margin-right, .very-small-margin-right { margin-right: 6px; }
    .xs-margin-top, .very-small-margin-top { margin-top: 6px; }
    .small-margin-bottom { margin-bottom: 15px; }
    .small-margin-left { margin-left: 15px; }
    .small-margin-right { margin-right: 15px; }
    .small-margin-top { margin-top: 15px; }
    .margin-bottom { margin-bottom: 30px; }
    .margin-left { margin-left: 30px; }
    .margin-right { margin-right: 30px; }
    .margin-top { margin-top: 30px; }

    .large-margin-bottom { margin-bottom: 50px; }
    .large-margin-left { margin-left: 50px; }
    .large-margin-right { margin-right: 50px; }
    .large-margin-top { margin-top: 50px; }

    .border { border: 1px solid #ddd; }
    .border-bottom { border-bottom: 1px solid #ddd; }
    .border-top { border-top: 1px solid #ddd; }
    .border-left { border-left: 1px solid #ddd; }
    .border-right { border-right: 1px solid #ddd; }

    .last-child-no-border-bottom:last-child { border-bottom: none; }
    .last-child-no-padding-bottom:last-child { padding-bottom: 0px; }
    .last-child-no-margin-bottom:last-child { margin-bottom: 0px; }

    .width10pct { width: 10%; }
    .width15pct { width: 15%; }
    .width20pct { width: 20%; }
    .width30pct { width: 30%; }
    .width40pct { width: 40%; }
    .width50pct { width: 50%; }
    .width60pct { width: 60%; }
    .width70pct { width: 70%; }
    .width80pct { width: 80%; }
    .width90pct { width: 90%; }

    .line-through {
        text-decoration: line-through;
    }

    .note {
        font-size: 13px;
        color: #999;
    }
    .error, .danger, .red {
        color: @red;
        font-weight: 700;
    }
    .success, .green {
        color: @green;
        font-weight: 700;
    }
    .warning, .orange {
        color: @orange;
    }
    .link {
        cursor: pointer;
        color: blue;
        &:hover {
            text-decoration: underline;
        }
    }

    .dot {
        background: #777;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        &.green {
            background: @green;
        }
        &.red {
            background: @red;
        }
    }

    table {
        width: 100%;
        border-spacing: 0px;
        border-collapse: collapse;
        // border-top: 1px solid #ddd;
        thead tr th, tbody tr td {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            border-bottom: 1px solid #ddd;
            font-size: 14px;
            &:nth-child(1) {
                padding-left: 12px;
            }
            &:last-child {
                padding-right: 12px;
            }
        }
        thead {
            tr th {
                border-bottom: 2px solid @base-color;
                // background: #efefef;
                // text-transform: uppercase;
                font-weight: 900;
                padding-bottom: 8px;
            }
        }
        tbody tr {
            &.disabled {
                color: #aaa;
                text-decoration: line-through;
            }
        }
    }
    .smaller-font table {
        thead tr th, tbody tr td {
            font-size: 11px;
            padding: 6px;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }

    .diagnostics-tabs {
        width: 100%;
        .diagnostics-tab {
            flex-grow: 1;
        }
    }

    .menu {
        width: 300px;
        .menu-item {
            cursor: pointer;
            margin-bottom: 15px;
            font-weight: 900;
            font-size: 16px;
            text-transform: uppercase;
            display: flex;
            align-items: center;
            color: #888;
            .icon {
                margin-right: 10px;
                svg {
                    width: 24px !important;
                    height: 24px !important;
                    fill: #888;
                }
            }
            &:hover {
                color: #535353;
                svg {
                    fill: #535353;
                }
            }
            &.active {
                color: @base-color;
                svg {
                    fill: @base-color;
                }
            }
        }
    }

    .diagnostic-line {
        margin-bottom: 10px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        background: #fff;
        font-size: 15px;
        .icon {
            margin-right: 8px;
        }
        .date {
            margin-top: 4px;
            font-size: 12px;
            color: #999;
        }
        &.error {
            svg {
                fill: @red;
            }
        }
        &.not-fulfilled {
            opacity: 0.3;
            text-decoration: line-through;
        }
        &.pending {
            color: #bbb;
            svg {
                fill: #bbb;
            }
        }
    }

    .input-row {
        display: flex;
        .label {
            width: 170px;
            font-weight: 900;
        }
    }

    .user-selector {
        position: relative;
        margin-left: 15px;
        .user-selected {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 10px;
            font-weight: 700;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: 2px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;
        }
        select {
            width: 240px;
        }
        .select-wrapper {
            position: absolute;
            top: 40px;
            background: #fff;
            padding: 15px;
            border: 1px solid #aaa;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
            z-index: 1001;
        }
        &:hover {
            .select-wrapper {
                // display: block;
            }
        }
    }

    .group-title {
        font-weight: 900;
        margin-top: 20px;
        margin-left: 15px;
        margin-bottom: 7px;
        font-size: 12px;
        text-transform: uppercase;
        cursor: default;
        color: #aaa;
    }

    .pins {
        display: flex;
        flex-wrap: wrap;
        padding: 15px;
        .pin {
            width: 317px;
            margin-bottom: 30px;
            background: #fff;
            box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
            border: 1px solid #ddd;
            padding: 30px;
            &:nth-child(3n-4) {
                margin-right: 30px;
                margin-left: 30px;
            }
            h3 {
                margin: 0;
            }
            .messages {
                width: 100%;
            }
            .events {
                width: 100%;
                .event {
                    display: flex;
                    margin-top: 15px;
                    font-size: 14px;
                    width: 100%;
                    .buttons {
                        opacity: 0;
                        flex-grow: 1;
                        text-align: right;
                        margin-left: 15px;
                    }
                    .note {
                        opacity: 0;
                    }
                    &:hover {
                        .buttons, .note {
                            opacity: 1;
                        }
                    }
                    .worker {
                        border-radius: 4px;
                        padding: 8px;
                        padding-left: 10px;
                        padding-right: 10px;
                        font-size: 14px;
                        display: inline-flex;
                        align-items: center;
                        border: 1px solid #afafaf;
                        color: #afafaf;
                        .svg-icon, svg {
                            margin: 0px;
                            width: 18px !important;
                            height: 18px !important;
                        }
                        .svg-icon {
                            margin-right: 6px;
                        }
                        svg {
                            fill: #afafaf;
                        }
                    }
                }
            }
        }
    }

    .tags {
        display: flex;
        .tag {
            // background: #535353;
            padding: 8px;
            border: 1px solid @base-color;
            padding-left: 14px;
            padding-right: 14px;
            border-radius: 4px;
            margin-right: 10px;
            // color: #fff;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            &:last-child {
                margin-right: 0px;
            }
        }
    }

    .order-stage {
        position: relative;
        &.cancelled {
            .groups {
                opacity: 0.7;
            }
        }
        .cancelled-label {
            position: absolute;
            z-index: 100;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            div {
                color: #535353;
                font-weight: bold;
                font-size: 48px;
                text-transform: uppercase;
                letter-spacing: 4px;
                transform: rotate(-10deg);
            }
        }
        .groups {
            display: flex;
            .group {
                flex-grow: 1;
                flex-basis: 0;
                .circle {
                    margin-right: 15px;
                    width: 20px;
                    height: 20px;
                    border: 3px solid #efefef;
                    border-radius: 50%;
                    position: relative;
                    background: #fff;
                    svg {
                        fill: #fff;
                        width: 20px !important;
                        height: 20px !important;
                        z-index: 100;
                        position: absolute;
                        top: 0px;
                        left: 0px;
                    }
                }
                .name {
                    padding-bottom: 15px;
                    display: flex;
                    align-items: center;
                    border-bottom: 3px solid #efefef;
                    margin-bottom: 15px;
                    font-size: 18px;
                    font-weight: 700;
                    color: #777;
                    .circle {
                        margin-right: 15px;
                        width: 20px;
                        height: 20px;
                        border: 3px solid #efefef;
                        border-radius: 50%;
                    }
                }
                .items {
                    .item {
                        font-size: 13px;
                        font-weight: 300;
                        color: #999;
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        position: relative;
                        .line {
                            width: 3px;
                            background: #efefef;
                            position: absolute;
                            top: -8px;
                            bottom: -8px;
                            left: 11.5px;
                        }
                        .note {
                            font-size: 11px;
                            margin-top: 2px;
                            font-weight: 300;
                            transition: 300ms;
                        }
                        .buttons {
                            // display: none;
                            .toggle-buttons {
                                // display: none;
                                padding: 4px;
                                padding-left: 7px;
                                padding-right: 7px;
                                cursor: pointer;
                                position: absolute;
                                right: 15px;
                                top: 0px;
                                border: 1px solid @base-color;
                                display: none;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                border-radius: 2px;
                                div {
                                    background: @base-color;
                                    width: 3px;
                                    height: 3px;
                                    margin-top: 2px;
                                    margin-bottom: 2px;
                                }
                                &:hover {
                                    border-color: lighten(@base-color, -10%);
                                    div {
                                        background: lighten(@base-color, -10%);
                                    }
                                }
                            }
                        }
                        .inspect-link {
                            display: none;
                        }
                        &:hover {
                            .buttons {
                                .toggle-buttons {
                                    display: flex;
                                }
                            }
                            .inspect-link {
                                display: inline-block;
                            }
                        }
                        &:nth-child(1) {
                            .line {
                                top: -15px;
                            }
                        }
                        &:last-child {
                            margin-bottom: 0px;
                            .line {
                                bottom: 5px;
                            }
                        }
                        &.completed {
                            font-weight: 700;
                            color: @green;
                            .circle {
                                border-color: @green;
                                background: @green;
                                &::after {
                                    background-color: @green;
                                }
                            }
                            .line {
                                background: @green;
                            }
                        }
                        &.warning {
                            color: @warning;
                            .circle {
                                border-color: @warning;
                                background: @warning;
                            }
                            .line {
                                background: @warning;
                            }
                        }
                        &.failed {
                            color: @error;
                            .circle {
                                border-color: @error;
                                background: #fff;
                            }
                            svg {
                                fill: @error;
                            }
                            .line {
                                background: @error;
                            }
                        }
                    }
                }
                &.completed {
                    .name {
                        color: @green;
                        border-color: @green;
                    }
                    .name .circle {
                        // &::after {
                        //     background-color: @green;
                        //     background: @green;
                        // }
                        border-color: @green;
                        background: @green;
                    }
                }
                &.warning {
                    .name {
                        color: @warning;
                        border-color: @warning;
                    }
                    .name .circle {
                        border-color: @warning;
                        background: @warning;
                    }
                }
                &.failed {
                    .name {
                        color: @error;
                        border-color: @error;
                    }
                    .name .circle {
                        border-color: @error;
                        background: #fff;
                        svg {
                            fill: @error;
                        }
                    }
                }
            }
            &.no-items {
                border: 1px solid #efefef;
                .group {
                    border-right: 1px solid #efefef;
                    .name {
                        border: none;
                        margin: 0;
                        padding: 0;
                        padding: 30px;
                    }
                    &:last-child {
                        border-right: none;
                    }
                }
            }
        }
        &:hover {
            .reload-button {
                display: block;
            }
        }
        .reload-button {
            display: none;
            position: absolute;
            right: 0px;
            top: -10px;
        }
    }

    .account-links {
        display: flex;
        align-items: center;
        .account-link {
            position: relative;
            cursor: pointer;
            width: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .icon {
                svg {
                    width: 40px !important;
                    height: 40px !important;
                    fill: #fff; // @base-color;
                    fill: @base-color;
                    transition: 120ms;
                }
            }
            .text {
                display: none;
                font-size: 13px;
            }
            &:hover {
                .icon {
                    svg {
                        fill: lighten(@base-color, 10%);
                        // fill: #ddd;
                    }
                }
            }
        }
    }

    .statistic-number {
        text-align: right;
        font-weight: 300;
        font-size: 14px;
        strong, .number {
            display: block;
            font-size: 50px;
            font-weight: 900;
        }
    }

    .notifications {
        position: fixed;
        top: 60px;
        right: 30px;
        width: 500px;
        border: 2px solid @base-color;
        border-top: none;
        padding: 30px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        background: #fff;
        .notification-scheduled-call {
            &.flash {
                svg {
                    animation-name: notification-flash;
                    animation-duration: 1100ms;
                    animation-iteration-count: infinite;
                }
            }
        }
    }

    @keyframes notification-flash {
        0% {
            // background-color: #fff;
            transform: scale(1, 1);
        }
        50% {
            // background-color: gold;
            transform: scale(1.5, 1.5);
            fill: @red;
        }
        100% {
            // background-color: #fff;
            transform: scale(1, 1);
        }
    }

    .account-box {
        position: fixed;
        top: 60px;
        right: 30px;
        width: 500px;
        border: 2px solid @base-color;
        border-top: none;
        padding: 30px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        background: #fff;
    }

    .modal {
        // @modal-width: 700px;
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        // Must sit above the fixed nav header (z-index: 500), otherwise the
        // header overlaps the modal's top edge and hides the ✕ close button.
        z-index: 1000;
        .modal-wrapper {
            position: relative;
            // width: @modal-width;
        }
        .modal-content {
            border: 1px solid #535353;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
            padding: 30px;
            background: #fff;
            max-height: 70vh;
            overflow-y: scroll;
            position: relative;
        }
        .close-modal {
            position: absolute;
            top: -40px;
            right: -40px;
            border-radius: 50%;
            padding: 0px;
            width: 35px;
            height: 35px;
        }
    }

    .outfitmodal {
        background: rgba(0, 0, 0, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: 101;
        padding-top: 78px;
        .modal-wrapper {
            position: relative;
        }

        @media screen and (max-width: 1300px) {
            zoom: 75% !important;
        }

        @media screen and (min-width: 1301px) and (max-width: 1700px) {
            zoom: 85% !important;
        }

        .modal-wrapper.stylingViewModelClass {
            height: 90vh;
            width: -webkit-fill-available;
            padding-left: 50px;
            padding-right: 170px;

            @media screen and (max-width: 1300px) {
                height: 110vh;
            }

            @media screen and (min-width: 1301px) and (max-width: 1700px) {
                height: 100vh;
            }

            @media screen and (max-width: 1700px) {
                padding-left: 50px;
                padding-right: 120px;
            }

            @media screen and (max-width: 1500px) {
                padding-left: 50px;
                padding-right: 110px;
            }
        }

        .modal-content {
            border: 1px solid #535353;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
            padding: 0;
            background: #fff;
            max-height: 80vh;
            overflow-y: scroll;
            position: relative;
        }

        .modal-buttons {
            position: absolute;
            top: 0;
            right: -110px;

            .confirm-button {
                border: 1px solid #535353;
                padding: 0px 5px;
                width: 100px;
                height: 40px;
            }
            .edit-button {
                border: 1px solid #535353;
                margin-top: 10px;
                padding: 0px 5px;
                width: 100px;
                height: 40px;
            }
            .cancel-button {
                border: 1px solid #535353;
                margin-top: 10px;
                padding: 0px 5px;
                width: 100px;
                height: 40px;
            }
        }

        .view-modal-content {
            border: 1px solid #535353;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
            padding: 0;
            background: #fff;
            max-height: 75vh;
            overflow-y: scroll;
            position: relative;
        }

        .view-modal-content.stylingView {
            background: #fff;
            overflow-y: unset;
            position: relative;
            max-height: 100%;
        }

        .view-modal-buttons {
            position: absolute;
            top: 0;
            right: 30px;

            @media screen and (max-width: 1500px) {
                right: 5px;
            }

            @media screen and (min-width: 1501px) and (max-width: 1700px) {
                right: 10px;
            }


            .remove-button {
                border: 1px solid #535353;
                margin-top: 10px;
                padding: 0px 5px;
                width: 130px;
                height: 50px;
                font-size: 18px;

                @media screen and (max-width: 1700px) {
                    width: 100px;
                    height: 40px;
                    font-size: 15px;
                }
            }
            .new-cancel-button {
                border: 1px solid #535353;
                margin-top: 10px;
                padding: 0px 5px;
                width: 130px;
                height: 50px;
                font-size: 18px;

                @media screen and (max-width: 1700px) {
                    width: 100px;
                    height: 40px;
                    font-size: 15px;
                }
            }
        }
    }

    .feedbackSummaryModalClass.stylingProcess {
        font-size: 13px;
        .modal-wrapper{
            margin-top: 68px !important;
            width: 70vw !important;
            @media screen and (max-width: 1850px) {
                width: 90vw !important;
            }
        }

        .modal-content{
            @media screen and (max-height: 1300px) {
                max-height: 60vh;
            }
        }
    }


    .feedbackSummaryModalClass.letter {
        font-size: 23px;

        @media screen and (max-width: 1300px) {
            font-size: 20px;
        }

        .modal-wrapper{
            margin-top: 68px !important;
            width: 100vw !important;
            @media screen and (max-width: 1850px) {
                width: 100vw !important;
            }
        }

        .modal-content{
            padding: 30px;

            @media screen and (max-height: 1300px) {
                max-height: 90vh;
            }
        }
    }


    .not-loggedin-flash {
        position: absolute;
        top: 0px;
        right: 0px;
        background: red;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        animation-name: not-loggedin-flash;
        animation-duration: 1400ms;
        animation-iteration-count: infinite;
    }

    @keyframes not-loggedin-flash {
        0% {
            background-color: red;
        }
        50% {
            background-color: gold;
        }
        100% {
            background-color: red;
        }
    }

    .search-result {
        .search-icon {
            svg {
                width: 20px !important;
                height: 20px !important;
                fill: #535353;
            }
        }
    }

    .modern-grid {
        .flex;
        .cell {
            .flex-grow;
            .flex-basis;
            font-weight: 700;
            font-size: 17px;
            strong {
                display: block;
                font-weight: 300;
                font-size: 14px;
                text-transform: uppercase;
            }
        }
    }

    .tabs-list {
        position: relative;
        display: flex;
        align-items: center;
        .tab-list-item {
            position: relative;
            z-index: 100;
            display: flex;
            align-items: flex-end;
            height: 40px;
            transition: 300ms;
            font-size: 14px;
            // text-transform: uppercase;
            font-weight: 300;
            padding-bottom: 6px;
            padding-right: 30px;
            border-bottom: 2px solid #ddd;
            // color: #aaa;
            &:hover {
                cursor: pointer;
                border-color: lighten(@base-color, 20%);
            }
            &.active {
                color: @base-color;
                font-weight: 900;
                font-size: 18px;
                border-color: @base-color;
                // padding-left: 50px;
                // padding-right: 50px;
            }
        }
        .filler {
            position: absolute;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            flex-grow: 1;
            border-bottom: 2px solid #ddd;
        }
    }

    .email-history-item {
        width: 500px;
        margin: auto;
        align-items: center;
        margin-bottom: 30px;
        .icon {
            position: relative;
            margin-right: 30px;
            .svg {
                position: relative;
                z-index: 100;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50px;
                height: 50px;
                background: #fff;
                border: 3px solid #ddd;
                border-radius: 50%;
                .svg-icon {
                    flex-grow: 0;
                    flex-shrink: 0;
                }
                svg {
                    margin-top: 1px;
                    flex-grow: 0;
                    flex-shrink: 0;
                    width: 28px !important;
                    height: 28px !important;
                    fill: #ccc;
                }
            }
            &::after {
                z-index: 50;
                content: "";
                position: absolute;
                left: 26px;
                top: -15px;
                bottom: -15px;
                width: 3px;
                background: #ddd;
            }
        }
        .text {
            font-size: 16px;
            .subject {
                font-weight: 300;
                margin-bottom: 2px;
            }
            .date {
                font-weight: 700;
                font-size: 13px;
            }
        }
        &:nth-child(1) {
            .icon {
                &::after {
                    top: 50%;
                }
            }
        }
        &:last-child {
            .icon {
                &::after {
                    bottom: 50%;
                }
            }
        }
    }

    .stylist-timeslot-item {
        display: flex;
        border: 1px solid #ddd;
        margin-bottom: 5px;
        .date {
            background: #efefef;
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #ddd;
        }
        .times {
            display: flex;
            align-items: center;
            padding: 15px;
            flex-grow: 1;
            .time {
                margin-right: 15px;
                cursor: pointer;
            }
            .time-wrapper {
                padding: 10px;
                border-radius: 6px;
                border: 1px solid #ddd;
            }
        }
    }

    .material {
        position: relative;
        width: 240px;
        height: 40px;
        .label {
            transition: 120ms;
            font-size: 16px;
            position: absolute;
            top: 16px;
            pointer-events: none;
        }
        input, select {
            border: none;
            outline: none;
            width: 100%;
            padding: 0px;
            padding-top: 20px;
            padding-bottom: 4px;
            vertical-align: bottom;
            border-radius: 0px;
        }
        &.text {

        }
        &.number {

        }
        &.short {
            width: 140px;
        }
        &.long {
            width: 300px;
        }
        &.dropdown {
            .search-icon {
                position: absolute;
                top: 10px;
                right: 22px;
                cursor: pointer;
                z-index: 50;
            }
            .filter-wrapper {
                position: absolute;
                top: 0px;
                right: 0px;
                left: 100%;
                overflow: hidden;
                z-index: 20;
                transition: 200ms;
            }
            &.show-filter {
                .filter-wrapper {
                    left: 50px;
                }
            }
            select {
                padding-left: 0px;
                border: 1px solid #fff;
                border-bottom: 2px solid #ddd;
            }
        }
        &.toggle {
            display: flex;
            align-items: center;
            position: relative;
            .frame {
                flex-shrink: 0;
                flex-grow: 0;
                cursor: pointer;
                background: #efefef;
                height: 20px;
                position: relative;
                width: 36px;
                border-radius: 3px;
                border: 1px solid #ccc;
                .pin {
                    position: absolute;
                    width: 18px;
                    left: 2px;
                    top: 2px;
                    bottom: 2px;
                    border-radius: 3px;
                    transition: 200ms;
                    background: #aaa;
                }
                &.on {
                    .pin {
                        left: 16px;
                        background: @green;
                    }
                }
            }
            .text {
                cursor: pointer;
                flex-shrink: 0;
                flex-grow: 0;
                width: 300px;
                margin-left: 15px;
            }
            .tooltip {
                position: absolute;
                top: 100%;
                left: 0px;
                pointer-events: none;
                border: 1px solid #343434;
                padding: 15px;
                box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
                transition: 200ms;
                transform: scale(0, 0);
                background: #fff;
                z-index: 200;
            }
            &:hover {
                .tooltip {
                    transform: none;
                }
            }
        }
        &.text, &.number, &.dropdown {
            border-bottom: 2px solid #ddd;
        }
        &.focus {
            border-color: @blue;
        }
        &.has-value {

        }
        &.focus, &.has-value {
            .label {
                font-size: 14px;
                top: 0px;
            }
        }
        &.disabled {

        }
    }

    #interface-message {
        display: flex;
        justify-content: center;
        position: fixed;
        bottom: 40px;
        left: 0px;
        right: 0px;
        z-index: 1000;
        .message {
            background: #fff;
            background: linear-gradient(45deg, lighten(@green, -5%), lighten(@green, 5%));
            border: 1px solid #ccc;
            border: 1px solid rgba(0, 0, 0, 0.3);
            border-radius: 4px;
            color: #fff;
            padding: 12px;
            padding-left: 16px;
            padding-right: 16px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
        }
    }

</style>
